import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { AppDispatch } from 'store/index';
import { HttpMethods } from 'api/types';
import {
  OP_PLUS_ADDED_HASH,
  showAndHideToast,
} from 'components/Common/OpPlusAddedNotification/OpPlusAddedNotification';
import redirectToCartOperation from './redirectToCartOperation';
import { setAddingOpPlusToBasketAction } from '../slice';

const addOPPlusSubscriptionAndRedirectToCartOperation =
  (showSuccessMessage?: boolean, forceRedirectToUrl?: string) => async (dispatch: AppDispatch) => {
    dispatch(setAddingOpPlusToBasketAction(true));
    try {
      await apiRequest(endpoints.opPlusV1Cart, { isNativeAppRequest: false }, HttpMethods.POST, 'data');

      if (showSuccessMessage) {
        showAndHideToast();
      }
      if (forceRedirectToUrl) {
        window.location.href = `${forceRedirectToUrl}#${OP_PLUS_ADDED_HASH}`;
        return;
      }
      dispatch(redirectToCartOperation());
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Can't add OPPlus to the cart", e);
      dispatch(setAddingOpPlusToBasketAction(false));
    }
  };

export default addOPPlusSubscriptionAndRedirectToCartOperation;
